import React, { PropTypes } from 'react'

const EverlanceIcon = ({width='29', height='34'}) =>
  <svg width={width} height={height} viewBox="0 0 29 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Dashboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="SETTINGS" transform="translate(-115.000000, -21.000000)" stroke="#31B59F">
              <g id="Logo-100" transform="translate(116.000000, 22.000000)">
                  <path d="M0.851775922,31.657188 C0.358541201,31.8992332 0.130793556,31.6868152 0.34413195,31.1802587 L13.184636,0.691414722 C13.3975067,0.185968719 13.7411261,0.184858206 13.9531697,0.691414722 L26.7157432,31.1802587 C26.927322,31.6857047 26.6939513,31.895545 26.200703,31.6520151 L13.5700725,25.4159356 L0.851775922,31.657188 Z" id="Path-7"></path>
                  <polygon id="Path-8" fill="#31B59F" points="13.5700725 0.0675841375 13.5700725 25.4159356 26.8704384 31.8676585"></polygon>
              </g>
          </g>
      </g>
  </svg>

const Logo = (props) => {
  return (
    <a alt="everlance" className="logo" href="/"><EverlanceIcon/></a>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/core/components/Logo.js